export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-6012HD_white-e8a668e31252fa4374be27c2dfd06427.webp";